import React from 'react';
import SideBar from '../../navigation/sidebar.js';
import { AppLayout } from '@amzn/awsui-components-react'; 
import WorkflowExecutionsTable from './table/table.js';
import AppContext from "../../context/AppContext";
import {getSidebarItemFromPageStage} from "../home/home";

class WorkflowExecutions extends React.Component {
    static contextType = AppContext;
    render() {
        return (
            <AppLayout
                content={<WorkflowExecutionsTable />}
                navigation={<SideBar activeHref="/workflow_executions" items={getSidebarItemFromPageStage(this.context.pageStage)}/>}
                navigationOpen={true}
                toolsHide={true}
            />
        );
    }
}

export default WorkflowExecutions;
